<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>

  <div id="page-user-list">

    <vx-row class="flex justify-between">
      <h2 class="mb-1">Sub General Ledger</h2>
      <h5 class="mt-2">{{accountCode}} - {{accountName}}</h5>
      <!-- <vs-button class="px-4" color="primary" type="filled" icon-pack="feather" icon="icon-plus">Tambah Laporan</vs-button> -->
    </vx-row>

    <vx-card ref="filterCard" title="Filters" class="user-list-filters mt-6" actionButtons @refresh="resetColFilters" @remove="resetColFilters">
      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Cari Data</label>
          <vs-input class="mb-4 md:mb-0 w-full" v-model="searchQuery" @input="updateSearchQuery" placeholder="Masukkan kata kunci..." />
        </div>
        <!-- <div class="vx-col md:w-1/3 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Filter Tanggal</label>
          <vs-dropdown vs-custom-content vs-trigger-click class="w-full">
            <a class="filter-date flex justify-center items-center" ref="btnDropdown" href.prevent>
              <span>{{startDate}} s.d. {{endDate}}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4 ml-1" />
            </a>

            <vs-dropdown-menu>
              <div class="container py-4">
                <div class="start-date">
                  <label class="text-sm opacity-75">Tanggal Awal</label>
                  <vs-input class="w-full" v-mask="'##-##-####'" v-model="startDate" v-validate="'required'"/>
                  <vs-input class="w-full" v-mask="'##-##-####'" v-model="startDate" v-validate="'required'" name="date" />
                </div>
                <div class="end-date mt-2">
                  <label class="text-sm opacity-75 mt-4">Tanggal Akhir</label>
                  <vs-input class="w-full" v-mask="'##-##-####'" v-model="endDate" v-validate="'required'"/>
                  <vs-input class="w-full" v-mask="'##-##-####'" v-model="endDate" v-validate="'required'" name="date" />
                </div>
                <vs-button @click.prevent="filterDate()" width="100%" color="success" type="gradient" class="mt-4 w-full">Terapkan</vs-button>
              </div>
            </vs-dropdown-menu>

          </vs-dropdown>
        </div> -->
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Start Date</label>
          <div class="flex items-center">
                 <vs-button icon @click="prevMonthStart" :disabled="selectedIndexStart === 0">‹</vs-button>

              <vs-select v-model="selectedMonthStart" class="mx-3" @change="handleSelectMonthStart" style="width: 150px">
                <vs-select-item
                  v-for="(month, index) in months"
                  :key="index"
                  :value="month.value"
                  :text="month.label"
                />
              </vs-select>

              <vs-button icon @click="nextMonthStart" :disabled="selectedIndexStart === months.length - 1">›</vs-button>
              </div>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">End Date</label>
          <div class="flex items-center">
                 <vs-button icon @click="prevMonthEnd" :disabled="selectedIndexEnd === 0">‹</vs-button>

              <vs-select v-model="selectedMonthEnd" class="mx-3" @change="handleSelectMonthEnd" style="width: 150px">
                <vs-select-item
                  v-for="(month, index) in months"
                  :key="index"
                  :value="month.value"
                  :text="month.label"
                />
              </vs-select>

              <vs-button icon @click="nextMonthEnd" :disabled="selectedIndexEnd === months.length - 1">›</vs-button>
              </div>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <!-- <vs-button @click="printSubGL" class="mt-6 mr-2" color="primary" type="filled">Print</vs-button> -->
          <vs-dropdown>
            <vs-button color="success" type="filled" class="text-sm mt-6 mr-2">
              {{$i18n.t('PrintData')}}
            </vs-button>
            <vs-dropdown-menu class="w-48">
              <vs-dropdown-item @click="printSubGLPDF">
                <i class="bx bxs-file-pdf mr-2 text-red-600"></i> Save as PDF
              </vs-dropdown-item>
              <vs-dropdown-item @click="printSubGLExcel">
                <i class="bx bxs-file-export mr-2 text-green-600"></i>Export to Excel
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
          <vs-button to="/general-ledgers" class="mt-6" color="danger" type="filled">Kembali</vs-button>
        </div>
      </div>
    </vx-card>

    <div class="vx-card p-6 pt-3 mt-6" style="min-height: 100%" v-show="loaded">
      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="subGLData"
         :pinnedRowBottom="pinnedBottomRow"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="false"
        :pagination="false"
        :enableRtl="$vs.rtl"
        :frameworkComponents="frameworkComponents"
        :loadingOverlayComponent="loadingOverlayComponent"
        :loadingOverlayComponentParams="loadingOverlayComponentParams">
      </ag-grid-vue>

    </div>

  </div>

</template>

<script>
import moment from 'moment'
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker'

import Vue from 'vue'
import htmlToPaper from 'vue-html-to-paper'
const options = {
  name: '',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ]
}
Vue.use(htmlToPaper, options)

// Store Module
import moduleGL from '@/store/general-ledger/moduleGL.js'

// Cell Renderer
import CellRendererLink from './cell-renderer/CellRendererLink.vue'
import CellRendererStatus from './cell-renderer/CellRendererStatus.vue'
import CellRendererVerified from './cell-renderer/CellRendererVerified.vue'
import CellRendererActions from './cell-renderer/CellRendererActions.vue'


export default {
  components: {
    AgGridVue,
    vSelect,
    StatisticsCardLine,
    Datepicker,

    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererActions
  },
  data () {
    return {

      // Filter Options
      typeFilter: { label: 'All', value: 'all' },
      typeOptions: [
        { label: 'All', value: 'all' },
        { label: 'Kas Masuk', value: 'KM' },
        { label: 'Kas Keluar', value: 'KK' }
      ],
      startDate: moment(this.$route.query.startDate).format('DD-MM-YYYY'),
      endDate: moment(this.$route.query.endDate).format('DD-MM-YYYY'),
      selectedMonthStart: moment(this.$route.query.startDate).format('MM'),
      selectedMonthEnd: moment(this.$route.query.endDate).format('MM'),
      months: [
        { label: 'Januari', value: '01' },
        { label: 'Februari', value: '02' },
        { label: 'Maret', value: '03' },
        { label: 'April', value: '04' },
        { label: 'Mei', value: '05' },
        { label: 'Juni', value: '06' },
        { label: 'Juli', value: '07' },
        { label: 'Agustus', value: '08' },
        { label: 'September', value: '09' },
        { label: 'Oktober', value: '10' },
        { label: 'November', value: '11' },
        { label: 'Desember', value: '12' }
      ],


      accountCode: '',
      accountName: '',
      total_debit: '',
      total_credit: '',
      final_balance: '',
      loaded: false,
      subGLData: [],
      searchQuery: '',

      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        autoHeight: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: 'No Voucher',
          field: 'voucher_no',
          filter: true,
          width: 150
        },
        {
          headerName: 'Tanggal',
          field: 'date',
          filter: true,
          width: 150
        },
        {
          headerName: 'Deskripsi',
          field: 'description',
          filter: true,
          width: 400
        },
        {
          headerName: 'Debit',
          field: 'debit',
          filter: true,
          width: 150,
          cellStyle: { 'white-space': 'normal', 'line-height': 1.5 }
        },
        {
          headerName: 'Kredit',
          field: 'credit',
          filter: true,
          width: 150
        }
      ],

      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererStatus,
        CellRendererVerified,
        CellRendererActions
      }
    }
  },
  watch: {
    typeFilter (obj) {
      this.setColumnFilter('type', obj.value)
    }
  },
  computed: {
    paginationPageSize () {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    totalPages () {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get () {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set (val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    },
    company () {
      return JSON.parse(localStorage.getItem('activeCompany'))
    },
    pinnedBottomRow () {
      return [
        {
          description: 'TOTAL',
          debit: this.total_debit,
          credit: this.total_credit
        },
        {
          description: 'FINAL BALANCE',
          debit: '',
          credit: this.final_balance
        }
      ]
    },
    selectedIndexStart () {
      return this.months.findIndex(m => m.value === this.selectedMonthStart)
    },
    selectedIndexEnd () {
      return this.months.findIndex(m => m.value === this.selectedMonthEnd)
    }
  },
  methods: {
    printSubGLPDF () {
      this.$vs.loading({
        type: 'border',
        color: 'primary',
        text: 'Generating PDF...'
      })

      const payload = {
        company_id: this.company.id,
        startDate: this.startDate,
        endDate: this.endDate,
        accountId: this.$route.params.id,
        searchQuery: this.searchQuery
      }

      this.$store.dispatch('gl/exportPDF', payload)
        .then(() => {
          this.$vs.notify({
            title: 'Success',
            text: 'PDF generated successfully',
            color: 'success'
          })
        })
        .catch(error => {
          this.$vs.notify({
            title: 'Error',
            text: error.message || 'Failed to generate PDF',
            color: 'danger'
          })
        })
        .finally(() => {
          this.$vs.loading.close()
        })
    },
    printSubGLExcel () {
      this.$vs.loading({
        type: 'border',
        color: 'primary',
        text: 'Generating File Excel...'
      })

      const payload = {
        company_id: this.company.id,
        startDate: this.startDate,
        endDate: this.endDate,
        accountId: this.$route.params.id,
        searchQuery: this.searchQuery
      }

      this.$store.dispatch('gl/exportExcel', payload)
        .then(() => {
          this.$vs.notify({
            title: 'Success',
            text: 'Excel generated successfully',
            color: 'success'
          })
        })
        .catch(error => {
          this.$vs.notify({
            title: 'Error',
            text: error.message || 'Failed to generate Excel',
            color: 'danger'
          })
        })
        .finally(() => {
          this.$vs.loading.close()
        })
    },
    loading () {
      this.loaded = false

      this.$vs.loading({
        type: 'border',
        color: 'primary',
        text: 'Wait a minute, It\'s getting data.'
      })
    },
    getSubGL () {
      const self      = this
      // const userData  = this.$store.state.AppActiveUser
      self.subGLData = []
      const companyActive = JSON.parse(localStorage.getItem('activeCompany'))
      this.$store.dispatch('gl/fetchSubGL', {
        company_id: companyActive.id,
        accountId: this.$route.params.id,
        startDate: self.startDate,
        endDate: self.endDate
      })
        .then(res => {

          const data = res.data.data

          self.accountCode  = data.account_code
          self.accountName  = data.name
          // Bersihkan format ribuan dan ubah ke number
          const parseNumber = str => Number(String(str).replace(/\./g, '').replace(',', '.'))

          self.total_debit = new Intl.NumberFormat('id-ID').format(parseNumber(data.total_debit))
          self.total_credit = new Intl.NumberFormat('id-ID').format(parseNumber(data.total_credit))
          self.final_balance = new Intl.NumberFormat('id-ID').format(parseNumber(data.final_balance))


          data.transactions.forEach(value => {
            self.subGLData.push({
              voucher_no  : value.voucher.no_voucher,
              date        : value.voucher.transaction_date,
              description : value.description,
              debit       : new Intl.NumberFormat('id-ID').format(value.debit),
              credit      : new Intl.NumberFormat('id-ID').format(value.credit)
            })
          })
        })
        .catch(err => {
          this.$vs.notify({
            color: 'danger',
            title: 'Opps..',
            text: err
          })
        })
        .finally(() => {
          this.onLoaded()
          this.$nextTick(() => {
            this.gridApi.setPinnedBottomRowData(this.pinnedBottomRow)
          })
        })
    },
    onLoaded () {
      this.loaded = true
      this.$vs.loading.close()
    },
    refreshData () {
      this.getSubGL()
      this.loading()
    },
    filterDate () {
      if (this.startDate < this.endData) {
        this.$vs.notify({
          color: 'warning',
          title: 'Peringatan',
          text: 'Tanggal akhir tidak boleh melebihi tanggal awal'
        })
      } else {
        const elem = this.$refs.btnDropdown
        elem.click()

        this.refreshData()
      }
    },
    formatRupiah (value) {
      const val = (value / 1).toFixed(0).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    setColumnFilter (column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if (val !== 'all') {
        modelObj = { type: 'equals', filter: val }
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters () {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      // Reset Filter Options
      this.typeFilter = { label: 'All', value: 'all' }

      this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery (val) {
      this.gridApi.setQuickFilter(val)
    },
    prevMonthStart () {
      if (this.selectedIndexStart > 0) {
        this.selectedMonthStart = this.months[this.selectedIndexStart - 1].value
        this.startDate = moment(String(new Date(Number(localStorage.getItem('selectedYear')),  Number(this.months[this.selectedIndexStart - 1].value), 1))).format('DD-MM-YYYY')
        this.getSubGL()
      }
    },
    nextMonthStart () {
      if (this.selectedIndexStart < this.months.length - 1) {
        this.selectedMonthStart = this.months[this.selectedIndexStart + 1].value
        this.startDate = moment(String(new Date(Number(localStorage.getItem('selectedYear')),  Number(this.months[this.selectedIndexStart - 1].value), 1))).format('DD-MM-YYYY')
        this.getSubGL()
      }
    },
    handleSelectMonthStart () {
      this.startDate = moment(String(new Date(Number(localStorage.getItem('selectedYear')),  Number(this.selectedMonthStart - 1), 1))).format('DD-MM-YYYY')
      this.getSubGL()
    },
    prevMonthEnd () {
      if (this.selectedIndexEnd > 0) {
        this.selectedMonthEnd = this.months[this.selectedIndexEnd - 1].value
        this.endDate = moment(String(new Date(Number(localStorage.getItem('selectedYear')),  Number(this.months[this.selectedIndexEnd - 1].value), 1))).format('DD-MM-YYYY')
        this.getSubGL()
      }
    },
    nextMonthEnd () {
      if (this.selectedIndexEnd < this.months.length - 1) {
        this.selectedMonthEnd = this.months[this.selectedIndexEnd + 1].value
        this.endDate = moment(String(new Date(Number(localStorage.getItem('selectedYear')),  Number(this.months[this.selectedIndexEnd].value), 0))).format('DD-MM-YYYY')
        this.getSubGL()
      }
    },
    handleSelectMonthEnd () {
      this.endDate = moment(String(new Date(Number(localStorage.getItem('selectedYear')),  Number(this.selectedMonthEnd), 0))).format('DD-MM-YYYY')
      this.getSubGL()
    }
  },
  mounted () {
    this.gridApi = this.gridOptions.api

    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
      header.style.left = `-${  String(Number(header.style.transform.slice(11, -3)) + 9)  }px`
    }
    this.gridOptions.api.setDomLayout('autoHeight')
    this.gridOptions.api.sizeColumnsToFit()
    this.gridApi.setPinnedBottomRowData(this.pinnedBottomRow)
    // this.gridOptions.api.resetRowHeights()
    // this.gridOptions.api.showLoadingOverlay()
  },
  created () {
    if (!moduleGL.isRegistered) {
      this.$store.registerModule('gl', moduleGL)
      moduleGL.isRegistered = true
    }
    this.loading()
    this.getSubGL()
  }
}

</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}

.filter-date {
  border: 1px solid rgba(0, 0, 0, 0.2);
  color: #111;
  border-radius: 5px;
  padding: 10px;
}

.ag-grid-table {
  height: 100%;
}

.ag-theme-material .ag-row-selected {
  background-color: var(--app-secondary-border);
}

.ag-row .ag-cell {
  display: flex;
  align-items: center;
}

.ag-row .level-2 {
  padding-left: 50px;
}

.ag-row .level-3 {
  padding-left: 70px;
}

.ag-row .level-4 {
  padding-left: 90px;
}
</style>
